export const PurchaseStorageKey = {
  QUERY: 'purchase_journey_queryString',
  FIRST_NAME: 'purchase_journey_firstName',
  LAST_NAME: 'purchase_journey_lastName',
  EMAIL_ADDRESS: 'purchase_journey_emailAddress',
  POSTCODE: 'purchase_journey_postcode',
  PHONE_NUMBER: 'purchase_journey_phoneNumber',
  SELECTED_TRIAL: 'purchase_journey_selected_trial',
  JOURNEY: 'purchase_journey_type',
  SITE_ID: 'purchase_journey_site_id',
  LANGUAGE: 'purchase_journey_language',
  CLUB_NAME: 'purchase_journey_club_name',
  SIGNUP_REF: 'purchase_journey_signup_ref',
  PRICE_IN_PENNIES: 'purchase_journey_price_in_pennies',
  PACKAGE_KEY: 'purchase_journey_package_key',
  MEMBER_START_DATE: 'purchase_journey_member_start_date',
  FIRST_DIRECT_DEBIT_AMOUNT_IN_PENNIES: 'first_direct_debit_amount_in_pennies',
  REGULAR_MONTHLY_FEE_IN_PENNIES: 'regular_monthly_fee_in_pennies',
  RATE_CARD_TYPE: 'purchase_journey_rate_card_type',
  NUMBER_OF_CHILD_OLDER_ASSOCIATES: 'purchase_journey_number_of_child_older_associates',
  NUMBER_OF_CHILD_ASSOCIATES: 'purchase_journey_number_of_child_associates',
  NUMBER_OF_INFANT_ASSOCIATES: 'purchase_journey_number_of_infant_associates',
  NUMBER_OF_NANNY_ASSOCIATES: 'purchase_journey_number_of_nanny_associates',
  NUMBER_OF_PARTNERS: 'purchase_journey_number_of_partners',
  DELAYED_DIRECT_DEBIT_DATE: 'purchase_journey_delayed_direct_debit_date',
  MEMBERSHIP_TYPE: 'purchase_journey_membership_type',
  MEMBERSHIP_JOURNEY: 'purchase_journey_membership_journey',
  ENCODED_CONTACT_ID: 'purchase_journey_encoded_contact_id',
  MEMBERSHIP_DURATION: 'purchase_journey_membership_duration',
  CLUB_STATUS_FOR_JOINERS: 'purchase_journey_club_status',
  ASSOCIATES: 'purchase_journey_associates',
} as const;

export enum PurchaseJourneyType {
  JOIN_ONLINE = 'JOIN_ONLINE',
  JOIN_IN_CLUB = 'JOIN_IN_CLUB',
  TRIAL = 'TRIAL',
}
